import React from "react";
import { cn } from "@/lib/utils";
import { getIcon, IconName } from "@/lib/get-icon";
import { BENEFITS_ICON_STYLES } from "@/lib/utils";

export interface IconTextCardProps {
  icon?: IconName;
  className?: string;
  textClassName?: string;
  titleClassName?: string;
  title: string;
  descriptionClassName?: string;
  description: string;
}

const IconTextCard: React.FC<IconTextCardProps> = ({
  icon,
  className,
  textClassName,
  titleClassName,
  title,
  descriptionClassName,
  description,
}) => {
  return (
    <div
      className={cn(
        "flex flex-col items-start gap-2 rounded-3xl md:gap-4 lg:py-6",
        className
      )}
    >
      {typeof icon === "string"
        ? getIcon({
            name: icon as IconName,
            className: BENEFITS_ICON_STYLES,
          })
        : icon}
      <div className={cn("flex flex-col md:gap-2", textClassName)}>
        <h3
          className={cn(
            "font-montserrat text-subheading-3-500 text-neutral-500 lg:text-subheading-2",
            titleClassName
          )}
        >
          {title}
        </h3>
        <p
          className={cn(
            "font-roboto text-body-1-300 text-neutral-500",
            descriptionClassName
          )}
        >
          {description}
        </p>
      </div>
    </div>
  );
};

export default IconTextCard;
